<div class=" container-scroller">
    <!-- <nav class="navbar default-layout-navbar p-0 fixed-top d-flex flex-row" style="width: 260px;height: 140px;">
        <div class="text-center navbar-brand-wrapper d-flex align-items-center justify-content-center"
            style="border-right: 1px solid #9c9fa6;border-bottom: 1px solid #9c9fa6;">
            <img src="../../assets/POA_IconLogo.png" style="height:130px; " />
            <img src="../../assets/POA_TextLogo.png" style="padding-top: 65px;" />
        </div>

    </nav> -->
    <div class="container-fluid page-body-wrapper" style="padding-left: 260px; top: 50px; position: absolute; z-index: -1;">
        <!-- <nav class="sidebar sidebar-offcanvas" id="sidebar">
            <ul class="nav">

                <li class="nav-item">

                    <a class="nav-link" href="../../index.html">
                        <img src="../../assets/navIcon/Dashboard.png" />&nbsp;&nbsp;
                        <span class="menu-title">Dashboard</span>

                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="mdi.html">
                        <img src="../../assets/navIcon/Audit.png" />&nbsp;&nbsp;
                        <span class="menu-title">Audit</span>
                        <i class="mdi mdi-contacts menu-icon"></i>
                    </a>
                </li>

                <li class="nav-item">
                    <a class="nav-link" href="../forms/basic_elements.html">
                        <img src="../../assets/navIcon/License.png" />&nbsp;&nbsp;
                        <span class="menu-title">licence</span>
                        <i class="mdi mdi-format-list-bulleted menu-icon"></i>
                    </a>
                </li>


                <li class="nav-item">
                    <a class="nav-link" data-toggle="collapse" href="#ui-basic" aria-expanded="false"
                        aria-controls="ui-basic">
                        <img src="../../assets/navIcon/Master.png" />&nbsp;&nbsp;
                        <span class="menu-title">Master</span>
                        <i class="menu-arrow"></i>
                        <i class="mdi mdi-crosshairs-gps menu-icon"></i>
                    </a>
                    <div class="collapse" id="ui-basic">
                        <ul class="nav flex-column sub-menu">
                            <li class="nav-item"> <a class="nav-link" href="../ui-features/buttons.html">Prod</a></li>
                            <li class="nav-item"> <a class="nav-link">Notices</a></li>
                            <li class="nav-item"> <a class="nav-link">Ports</a></li>
                            <li class="nav-item"> <a class="nav-link">Country</a></li>
                            <li class="nav-item"> <a class="nav-link">Currency</a></li>
                        </ul>
                    </div>
                </li>
                <li class="nav-item">
                    <a class="nav-link" routerLink="/Portmaster">
                        <img src="../../assets/navIcon/Terms&Conditions.png" />&nbsp;&nbsp;
                        <span class="menu-title" style="font-size:13px;">Port</span>

                    </a>
                </li>

                <li class="nav-item">
                    <a class="nav-link" routerLink="/Chamaster">
                        <img src="../../assets/navIcon/Terms&Conditions.png" />&nbsp;&nbsp;
                        <span class="menu-title" style="font-size:13px;">CHA</span>

                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" routerLink="/countrymaster">
                        <img src="../../assets/navIcon/Terms&Conditions.png" />&nbsp;&nbsp;
                        <span class="menu-title" style="font-size:13px;">Terms & Conditions</span>

                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" routerLink="/currencymaster">
                        <img src="../../assets/navIcon/Copyrigths.png" />&nbsp;&nbsp;
                        <span class="menu-title" style="font-size:13px;">CopyRights</span>

                    </a>
                </li>

                <li class="nav-item">
                    <a class="nav-link" href="/">
                        <img src="../../assets/navIcon/Logout.png" />&nbsp;&nbsp;
                        <span class="menu-title" style="font-size:13px;">LogOut</span>

                    </a>
                </li>

            </ul>
        </nav> -->
        <div class="main-panel" >
            <div class="content-wrapper" style="padding: 1.5rem .8rem .5rem 2rem;">
                <div class="page-header">
                    <h2 class="page-title text-primary">Country</h2>
                </div>

                <div class="form" [hidden]="isShownWrite">
                    <div class="row" style="padding-bottom: 20px;">
                        <div class="col-lg-4" style="text-align: left;">
                            <label>Code </label><span style="color: red;">*</span><br />
                            <input type="text" id="CountryCode" [(ngModel)]="CountryCode" maxlength="2"
                                class="txt-input" />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-4" style="text-align: left;">
                            <label>Name </label><span style="color: red;">*</span><br />
                            <input type="text" id="CountryName" [(ngModel)]="CountryName" class="txt-input" />
                        </div>
                        <div class="col-lg-2" style="padding-top: 39px;"  [hidden]="isShownActive">
                            <input type="checkbox" [(ngModel)]="Status"> Set As Inactive
                          </div>
                        <div class="col-lg-2" style="padding-top: 30px;">      
                            <button class="bttn-save" (click)="SubmitCountry()"  [hidden]="isShownSaveBtn">SAVE</button>   &nbsp;&nbsp;
                            <button class="bttn-Update" (click)="UpdateCountry()" [hidden]="isShownUpdateBtn">Update</button>
                        </div>
                        <!-- <div class="col-md-2" style="padding-top: 30px;">  
                            
                        </div> -->
                        <div class="col-lg-2" style="padding-top: 30px;">
                            <button class="bttn-clear" (click)="ClearCountry()">CLEAR</button>
                        </div>
                    </div>

                    <div class="col-md-12" style="padding-bottom: 25px; text-align: Left;">
                        <span [hidden]="isShownError" style="color: red;">{{ErrorMsg}}</span>
                        <span [hidden]="isShownSuccess" style="color: green;">{{SuccessMsg}}</span>
                    </div>
                </div>
            </div>



            <div class="content-wrapper">
                <div class="row">
                    <div class="col-lg-12 grid-margin">
                        <div class="card">
                            <div class="card-body" style="width:fit-content;">
                                <div class="row">
                                    <div class="col-12 grid-margin">
                                        <div class="card">
                                            <div class="card-body" style="padding: 0;">
                                                <div class="col-lg-12 form-inline"
                                                    style="border: 1px solid #9c9fa6; padding: 5px;background-color: #f0f0f1">
                                                    <div class="col-lg-4"></div>
                                                    <div class="col-lg-8" >
                                                        <div class="form-group">
                                                            <div class="input-group">
                                                                <!-- <label style="padding-right: 25px;">Search</label> -->
                                                                <input type="text" placeholder="Search"
                                                                    [(ngModel)]="searchText"
                                                                    (keyup)="applyFilter($event.target.value)"
                                                                    class="txt-Search"> <i class="fa fa-search fa-2x"
                                                                    style="color:#38C3FA;position: absolute;    left: 72%; top: 3px;"></i>
                                                                <!-- <input type="text" class="form-control"
                                                                    placeholder="Search..." aria-label="Search..."
                                                                    aria-describedby="basic-addon2">
                                                                <div class="input-group-append">
                                                                    <button class="btn btn-sm btn-gradient-danger"
                                                                        type="button">Search</button>
                                                                </div> -->
                                                            </div>
                                                            <button type="button" class="btn btn-sm ">
                                                                <img src="../../assets/ExportPDF.png" />
                                                            </button>
                                                            <button type="button" class="btn  btn-sm">
                                                                <img src="../../assets/ExportExcel.png"
                                                                    (click)="exportexcel()" style="cursor: pointer;" />
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>


                                                <div class="col-sm-12 mat-elevation-z8"
                                                    style="box-shadow: unset;padding: 0px ;" #TABLE>
                                                    <table mat-table [dataSource]="dataSource" #table
                                                        style="width: 100%;" matSortmat-table [dataSource]="dataSource"
                                                        #table style="width: 100%;" matSort>
                                                        <ng-container matColumnDef="sno">
                                                            <th mat-header-cell *matHeaderCellDef
                                                                style="color: black !important;background-color: white">
                                                                S.NO </th>
                                                            <td mat-cell *matCellDef="let item; let j = index">
                                                                {{(j +1)  + (myPaginator.pageIndex * myPaginator.pageSize) }}
                                                            </td>
                                                        </ng-container>
                                                        <ng-container matColumnDef="countrycode">
                                                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                                style="color: black !important;background-color: white">
                                                                Country Code</th>
                                                            <td mat-cell *matCellDef="let element"
                                                                (click)="EditCountry(element)" style="cursor: pointer;">
                                                                {{element.countrycode}}
                                                            </td>
                                                        </ng-container>
                                                        <ng-container matColumnDef="countryname">
                                                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                                style="color: black !important;background-color: white">
                                                                Country Name</th>
                                                            <td mat-cell *matCellDef="let element"
                                                                (click)="EditCountry(element)" style="cursor: pointer;">
                                                                {{element.countryname}}
                                                            </td>
                                                        </ng-container>
                                                        <ng-container matColumnDef="status">
                                                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                                style="color: black !important;background-color: white">
                                                                Status</th>
                                                            <td mat-cell *matCellDef="let element"
                                                                (click)="EditCountry(element)" style="cursor: pointer;">
                                                                {{element.status}}
                                                            </td>
                                                        </ng-container>
                                                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                                        <tr mat-row *matRowDef="let row; columns: displayedColumns;">
                                                        </tr>
                                                    </table>
                                                    <mat-paginator #myPaginator [pageSizeOptions]="[5, 10,15, 20,30,40]"
                                                        showFirstLastButtons></mat-paginator>
                                                </div>


                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-4"></div>
                                    <div class="col-lg-4"></div>
                                    <div class="col-lg-4">
                                        <!-- <p class="text-primary" style="float:right"><i>
                                                &nbsp;</i>Page 1,2,3,4<i>&nbsp;></i></p> -->
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- partial:../../partials/_footer.html -->
            <footer class="footer">
                <div class="d-sm-flex justify-content-center">
                    <span class="d-block d-sm-inline-block">
                        © 2020 All Rights Reserved
                        <a href="https://www.sysmedacmicrosoft.com/#!/" target="_blank" style="color:black;">
                            <img src="../../assets/Logo-V3.png" width="70" />
                        </a>

                    </span>

                </div>
            </footer>
            <!-- partial -->
        </div>

    </div>
</div>